"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecurityConfig = void 0;
var SecurityConfig_1 = require("../interfaces/SecurityConfig");
var getSecurityConfig = function () {
    return {
        fieldNameMatchers: {
            amorphic: SecurityConfig_1.PiiLevelEnum.s1,
            authToken: SecurityConfig_1.PiiLevelEnum.s1,
            bankAccount: SecurityConfig_1.PiiLevelEnum.s1,
            bankAccountNumber: SecurityConfig_1.PiiLevelEnum.s1,
            creditCard: SecurityConfig_1.PiiLevelEnum.s1,
            creditCardNumber: SecurityConfig_1.PiiLevelEnum.s1,
            debitCard: SecurityConfig_1.PiiLevelEnum.s1,
            debitCardNumber: SecurityConfig_1.PiiLevelEnum.s1,
            driverLicense: SecurityConfig_1.PiiLevelEnum.s1,
            driverLicenseNumber: SecurityConfig_1.PiiLevelEnum.s1,
            govtId: SecurityConfig_1.PiiLevelEnum.s1,
            jwt: SecurityConfig_1.PiiLevelEnum.s1,
            key: SecurityConfig_1.PiiLevelEnum.s1,
            pass: SecurityConfig_1.PiiLevelEnum.s1,
            passportNumber: SecurityConfig_1.PiiLevelEnum.s1,
            password: SecurityConfig_1.PiiLevelEnum.s1,
            paymentABA: SecurityConfig_1.PiiLevelEnum.s1,
            paymentAccount: SecurityConfig_1.PiiLevelEnum.s1,
            paymentInstitutionName: SecurityConfig_1.PiiLevelEnum.s1,
            pin: SecurityConfig_1.PiiLevelEnum.s1,
            secret: SecurityConfig_1.PiiLevelEnum.s1,
            socialSecurityNumber: SecurityConfig_1.PiiLevelEnum.s1,
            ssn: SecurityConfig_1.PiiLevelEnum.s1,
            stateId: SecurityConfig_1.PiiLevelEnum.s1,
            stateIdentification: SecurityConfig_1.PiiLevelEnum.s1,
            taxIdentificationNumber: SecurityConfig_1.PiiLevelEnum.s1,
            taxpayerId: SecurityConfig_1.PiiLevelEnum.s1,
            token: SecurityConfig_1.PiiLevelEnum.s1,
            username: SecurityConfig_1.PiiLevelEnum.s1,
            visaNumber: SecurityConfig_1.PiiLevelEnum.s1,
            agentName: SecurityConfig_1.PiiLevelEnum.s2,
            clientName: SecurityConfig_1.PiiLevelEnum.s2,
            customerName: SecurityConfig_1.PiiLevelEnum.s2,
            email: SecurityConfig_1.PiiLevelEnum.s2,
            firstName: SecurityConfig_1.PiiLevelEnum.s2,
            fullName: SecurityConfig_1.PiiLevelEnum.s2,
            lastName: SecurityConfig_1.PiiLevelEnum.s2
        },
        patternMatchers: {
            socialSecurity: SecurityConfig_1.PiiLevelEnum.s1,
            xml: SecurityConfig_1.PiiLevelEnum.s1,
            email: SecurityConfig_1.PiiLevelEnum.s2
        }
    };
};
exports.getSecurityConfig = getSecurityConfig;
//# sourceMappingURL=security-config.js.map